import type { Ticket } from '../types';

export const mockTickets: Ticket[] = [
  {
    id: 'TKT-001',
    title: 'Login button not working on mobile devices',
    description: 'When attempting to login on mobile devices (iOS and Android), the login button does not respond to touch events. This issue started after the latest deployment on 2025-01-15.',
    status: 'open',
    priority: 'high',
    severity: 'major',
    category: 'Bug',
    component: 'Authentication',
    version: '2.1.0',
    reporter: 'John Doe',
    reporter_email: 'john.doe@example.com',
    assignee: 'Jane Smith',
    assignee_email: 'jane.smith@example.com',
    created_at: '2025-01-16T10:30:00Z',
    updated_at: '2025-01-17T14:20:00Z',
    resolved_at: null,
    closed_at: null,
    comments: [
      {
        id: 'CMT-001',
        ticket_id: 'TKT-001',
        author: 'Jane Smith',
        author_email: 'jane.smith@example.com',
        content: 'I am investigating this issue. Initial tests show it might be related to the touch event handlers.',
        created_at: '2025-01-17T14:20:00Z',
        is_private: false,
      }
    ],
    attachments: [],
    tags: ['mobile', 'authentication', 'urgent']
  },
  {
    id: 'TKT-002',
    title: 'Add dark mode support',
    description: 'Users have requested dark mode support for better viewing experience during night time. This should include a toggle in user settings and persist the preference.',
    status: 'in_progress',
    priority: 'medium',
    severity: 'normal',
    category: 'Feature Request',
    component: 'UI/UX',
    version: '2.2.0',
    reporter: 'Alice Johnson',
    reporter_email: 'alice.j@example.com',
    assignee: 'Bob Wilson',
    assignee_email: 'bob.wilson@example.com',
    created_at: '2025-01-10T08:15:00Z',
    updated_at: '2025-01-18T16:45:00Z',
    resolved_at: null,
    closed_at: null,
    comments: [
      {
        id: 'CMT-002',
        ticket_id: 'TKT-002',
        author: 'Bob Wilson',
        author_email: 'bob.wilson@example.com',
        content: 'Working on implementing CSS variables for theme switching. About 60% complete.',
        created_at: '2025-01-18T16:45:00Z',
        is_private: false,
      }
    ],
    attachments: [],
    tags: ['enhancement', 'ui', 'user-experience']
  },
  {
    id: 'TKT-003',
    title: 'Database connection timeout errors',
    description: 'Experiencing intermittent database connection timeout errors during peak hours (2-4 PM). Error logs show "connection pool exhausted" messages.',
    status: 'new',
    priority: 'critical',
    severity: 'blocker',
    category: 'Bug',
    component: 'Database',
    version: '2.1.0',
    reporter: 'System Monitor',
    reporter_email: 'monitor@system.com',
    assignee: null,
    assignee_email: null,
    created_at: '2025-01-19T14:30:00Z',
    updated_at: '2025-01-19T14:30:00Z',
    resolved_at: null,
    closed_at: null,
    comments: [],
    attachments: [],
    tags: ['database', 'performance', 'production']
  },
  {
    id: 'TKT-004',
    title: 'Export reports to Excel format',
    description: 'Add functionality to export reports in Excel (.xlsx) format in addition to existing PDF export.',
    status: 'resolved',
    priority: 'low',
    severity: 'minor',
    category: 'Feature Request',
    component: 'Reports',
    version: '2.1.5',
    reporter: 'Mike Brown',
    reporter_email: 'mike.b@example.com',
    assignee: 'Sarah Davis',
    assignee_email: 'sarah.davis@example.com',
    created_at: '2025-01-05T11:00:00Z',
    updated_at: '2025-01-15T09:30:00Z',
    resolved_at: '2025-01-15T09:30:00Z',
    closed_at: null,
    comments: [
      {
        id: 'CMT-003',
        ticket_id: 'TKT-004',
        author: 'Sarah Davis',
        author_email: 'sarah.davis@example.com',
        content: 'Implementation complete. Added Excel export using ExcelJS library. Ready for testing.',
        created_at: '2025-01-15T09:30:00Z',
        is_private: false,
      }
    ],
    attachments: [],
    tags: ['reports', 'export', 'enhancement']
  },
  {
    id: 'TKT-005',
    title: 'Improve search performance',
    description: 'Search queries taking too long (5-8 seconds) when searching across large datasets. Need to optimize database queries and add proper indexing.',
    status: 'in_progress',
    priority: 'high',
    severity: 'major',
    category: 'Performance',
    component: 'Search',
    version: '2.1.0',
    reporter: 'David Lee',
    reporter_email: 'david.lee@example.com',
    assignee: 'Jane Smith',
    assignee_email: 'jane.smith@example.com',
    created_at: '2025-01-12T13:20:00Z',
    updated_at: '2025-01-19T10:15:00Z',
    resolved_at: null,
    closed_at: null,
    comments: [
      {
        id: 'CMT-004',
        ticket_id: 'TKT-005',
        author: 'Jane Smith',
        author_email: 'jane.smith@example.com',
        content: 'Added composite indexes on frequently searched columns. Testing shows 60% improvement in query times.',
        created_at: '2025-01-19T10:15:00Z',
        is_private: false,
      }
    ],
    attachments: [],
    tags: ['performance', 'search', 'optimization']
  },
  {
    id: 'TKT-006',
    title: 'Typo in dashboard header',
    description: 'There is a typo in the dashboard header: "Dashbaord" should be "Dashboard".',
    status: 'closed',
    priority: 'low',
    severity: 'trivial',
    category: 'Bug',
    component: 'UI/UX',
    version: '2.0.5',
    reporter: 'Emma White',
    reporter_email: 'emma.w@example.com',
    assignee: 'Bob Wilson',
    assignee_email: 'bob.wilson@example.com',
    created_at: '2025-01-08T15:45:00Z',
    updated_at: '2025-01-08T16:20:00Z',
    resolved_at: '2025-01-08T16:10:00Z',
    closed_at: '2025-01-08T16:20:00Z',
    comments: [
      {
        id: 'CMT-005',
        ticket_id: 'TKT-006',
        author: 'Bob Wilson',
        author_email: 'bob.wilson@example.com',
        content: 'Fixed the typo and deployed.',
        created_at: '2025-01-08T16:10:00Z',
        is_private: false,
      }
    ],
    attachments: [],
    tags: ['ui', 'typo', 'quick-fix']
  }
];

export const categories = ['Bug', 'Feature Request', 'Performance', 'Security', 'Documentation'];
export const components = ['Authentication', 'UI/UX', 'Database', 'Reports', 'Search', 'API', 'Admin Panel'];
export const users = [
  { name: 'Jane Smith', email: 'jane.smith@example.com' },
  { name: 'Bob Wilson', email: 'bob.wilson@example.com' },
  { name: 'Sarah Davis', email: 'sarah.davis@example.com' },
  { name: 'Mike Brown', email: 'mike.b@example.com' },
];
